import type { FaireProductEntity } from "../../entity_types/product";

export const p_1r5nz0l4e6: FaireProductEntity = {
  token: "p_1r5nz0l4e6",
  type: "product",
  name: "Rainbow Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/113f221c6c242450e9f39da6649c0cc5f16a930a7cc4310748eb25635f2e3f95.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/71459ccb509a8f1218eb7c7c98884a37f9be2e5f292f2654781f2c18eb9eddba.jpeg",
    "https://cdn.faire.com/fastly/bba914e92c157fadb070cf54d37842fe1fd7d08964f4b661c3103f8817c446e8.jpeg",
    "https://cdn.faire.com/fastly/2b078a2d4472fb97f9a901ed248f9c220879697faa49472b67cd1c062cb6f1ca.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:52.514Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
